<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="small"
        @click="$refs.dialogCreate.toggleActive(true)"
      >Tambah Template Surat</vs-button>
      <vs-card>
        <global-header></global-header>
        <global-wrapper-list
          :loading="$apollo.queries.templateSurat.loading"
          :loadingType="'TwoLine'"
          :loadingList="5"
          :empty="templateSurat.length <= 0"
          :error="error"
          :btnShowMore="btnShowMore"
        >
          <div class="flex flex-col">
            <vs-table :data="templateSurat">
              <template slot="thead">
                <vs-th>No.</vs-th>
                <vs-th>Nama</vs-th>
                <vs-th>Kategori Surat</vs-th>
                <vs-th>Keterangan</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">{{ indextr }}</vs-td>
                  <vs-td :data="tr.nama">{{ tr.nama }}</vs-td>
                  <vs-td :data="tr.kategori_surat.nama">{{ tr.kategori_surat.nama }}</vs-td>
                  <vs-td :data="tr.keterangan">{{ tr.keterangan }}</vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vs-button
                        @click="$router.push({name: 'template-surat-detail', params: {uuid: tr.uuid }})"
                        color="primary"
                        size="small"
                        class="m-1"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                      >Detail</vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </global-wrapper-list>
      </vs-card>
      <DialogCreate
        ref="dialogCreate"
        :penggunaId="$sanctum.getUser().id"
        @submitCallback="refreshTemplateSuratQuery"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

import {ALL as ALL_TEMPLATE} from '@/query/template-surat';
import {GET_ALL as ALL_KATEGORI} from '@/query/kategori-surat';
import vSelect from "vue-select";
import DialogCreate from "./DialogCreate";

export default {
  components : {
    "v-select": vSelect,
    DialogCreate
  },
  data() {
    return {
      templateSurat : [],
      error: false,
      paginationPage: 1
    };
  },
  computed : {
    ...mapState({
      search: state => state.globalApp.search,
      filter: state => state.globalApp.filter.list
    }),
    btnShowMore() {
      return this.templateSurat.paginatorInfo
        ? this.templateSurat.paginatorInfo.hasMorePages
        : false;
    },
    filterForms(){
      return [
        {
          label: "Kategori Surat",
          value: "KATEGORI_SURAT_ID",
          component: "vs-select",
          options: this.kategoriSurat
        },
      ]
    },
    defaultVars() {
      const newWhere = { ...this.searchVars, ...this.filterVars };
      console.log(newWhere);
      return {
        perPage: 300,
        page: this.paginationPage,
        where: newWhere
      };
    },
    searchVars() {
      const query = this.search.query;
      return {
        OR: [
          {
            column: "NAMA",
            operator: "LIKE",
            value: `%${query}%`
          },
          {
            column: "KETERANGAN",
            operator: "LIKE",
            value: `%${query}%`
          }
        ]
      };
    },
    filterVars() {
      let filterModified = this.filter;
      const finalFilter = filterModified.map((item) => {
        return {
          column: item.type.value,
          value: item.query.value
        }
      }); 

      return {
        AND : [...finalFilter]
      }
    }
  },
  mounted(){
    this.$store.dispatch("globalApp/setHeaderTitle", 'Manajemen Template Surat');
  },
  apollo : {
    templateSurat : {
      query : ALL_TEMPLATE,
      update : (data) => data.templateSurat.data,
      variables(){
        return {
          ...this.defaultVars
        }
      },
      fetchPolicy: "cache-and-network",
    },
    kategoriSurat : {
      query : ALL_KATEGORI,
      update: data => {
        const list = data.kategoriSurat.data;
        return list.map(({ id, nama }) => ({
          value: id,
          label: nama
        }));
      },
      variables(){
        return {
          perPage: 300
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  methods : {
    refetchTemplateSuratQuery: _.debounce(function() {
      this.refreshTemplateSuratQuery();
    }, 300),
    refreshTemplateSuratQuery() {
      this.$nextTick().then(() => {
        this.error = false;
        this.paginationPage = 1;
        this.$apollo.queries.templateSurat.setVariables({ ...this.defaultVars });
        this.$apollo.queries.templateSurat.refetch();
      });
    },
  },
  watch : {
    kategoriSurat: {
      handler(){
       this.$store.dispatch("globalApp/setFilterForms", this.filterForms);
      }
    },
    search: {
      handler() {
        this.refetchTemplateSuratQuery();
      },
      deep: true
    },
    filter: {
      handler() {
        this.refetchTemplateSuratQuery();
      },
      deep: true
    }
  }
};
</script>